import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import MmRating from 'components/MmRating'
import React, { useState } from 'react'

interface RateUsPopupProps {

}

interface Form {
  price?: number
  cleanliness?: number
  security?: number
  location?: number
  comments: string
}

const options: (keyof Omit<Form, 'comments'>)[] = ['price', 'cleanliness', 'security', 'location']

const RateUsPopup: React.FC<RateUsPopupProps> = () => {
  const [isLoading, setLoading] = useState(false)
  const [form, setForm] = useState<Form>({
    price: 0,
    cleanliness: 0,
    security: 0,
    location: 0,
    comments: ''
  })

  const { replace } = useHistory()
  const { t } = useTranslation('warehouse')
  const send = async () => {
    if (isLoading) return
    setLoading(true)
    setTimeout(() => {
      replace('/')
    }, 1000)
  }

  return (
    <Popup>
      <div className='popup__rateUs'>
        <div className='popup__title'>
          <div>{t('rateUs')}</div>
        </div>
        <div className='rateUs__list'>
          {options.map(option => <MmRating
            key={option}
            starSize={24}
            secFont={false}
            text={t(option)}
            number={form[option] || 0}
            onChange={value => {
              setForm(prev => ({ ...prev, [option]: value }))
            }}
          />)}
          <div className='input__default'>
            <label
              className='input__label'
              htmlFor='comments'>
              <span>{t('comments')}</span>
            </label>
            <div className='input__main'>
              <textarea
                id='comments'
                value={form.comments}
                placeholder={t('whatCanWeImprove')}
                onChange={e => {
                  setForm(prev => ({ ...prev, comments: e.target.value }))
                }}
              />
            </div>
          </div>
        </div>
        <div className='rateUs__buttons'>
          <ArrowBtn
            enlarged
            isLoading={isLoading}
            text={t('send')}
            action={send}
          />
          <BackBtn />
        </div>
      </div>
    </Popup>
  )
}

export default RateUsPopup